import constants from './constants';
import { Media } from './types';

export const getMediaUrl = (media: Media | null) => {
  return media ? `${constants.mediaUrl}/${media.id}/${media.file_name}` : '';
};
